import api, { buildQueryString } from './api';
import type {
  Tenant,
  TenantStatus,
  PaginatedResponse,
  ApiResponse,
  PaginationParams,
  CreateTenantForm,
  SuperAdminStats,
} from '../types';

export const tenantService = {
  async getAll(params?: PaginationParams & { status?: TenantStatus }): Promise<PaginatedResponse<Tenant>> {
    const qs = buildQueryString(params as Record<string, unknown>);
    const response = await api.get<PaginatedResponse<Tenant>>(`/api/tenants${qs}`);
    return response.data;
  },

  async getById(id: string): Promise<Tenant> {
    const response = await api.get<ApiResponse<Tenant>>(`/api/tenants/${id}`);
    return response.data.data;
  },

  async create(data: CreateTenantForm): Promise<Tenant> {
    const response = await api.post<ApiResponse<Tenant>>('/api/tenants', data);
    return response.data.data;
  },

  async update(id: string, data: Partial<CreateTenantForm>): Promise<Tenant> {
    const response = await api.patch<ApiResponse<Tenant>>(`/api/tenants/${id}`, data);
    return response.data.data;
  },

  async updateStatus(id: string, status: TenantStatus): Promise<Tenant> {
    const response = await api.patch<ApiResponse<Tenant>>(`/api/tenants/${id}/status`, { status });
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/tenants/${id}`);
  },

  async getStats(): Promise<SuperAdminStats> {
    const response = await api.get<ApiResponse<SuperAdminStats>>('/api/tenants/stats');
    return response.data.data;
  },

  async assignPlan(tenantId: string, planId: string): Promise<Tenant> {
    const response = await api.post<ApiResponse<Tenant>>(`/api/tenants/${tenantId}/assign-plan`, { planId });
    return response.data.data;
  },
};
